import type { Booking } from "../../types/Booking";

export function bookingToEventDescription(booking: Booking): string {
    return `${booking.numberOfGuests ? `Number of guests: ${booking.numberOfGuests}\n\n` : ""}${booking.rooms ? `Rooms: ${booking.rooms}\n\n` : ""}${booking.reference ? `Booking reference: ${booking.reference}\n\n` : ""}See the full booking details in the Albertine app.${booking.googleUrl ? `\n\nView on map: ${booking.googleUrl}` : ""}`;
}
